import React, { useState } from "react";
import { Form, FormInstance } from "antd";
import FileUploaderWanda from "../../../../containers/file-uploader-wanda/FileUploaderWanda";
import PhotoUploadErrorModal from "../../../CreatePerson/Modals/PhotoUploadErrorModal";
import styles from "../MemberProfile.module.scss";
import defaultImage from "../../../../assets/images/uploadPic.svg";

type Props = {
  form: FormInstance;
  validateForm: Function;
};

function ProfilePhoto({ form, validateForm }: Props) {
  const [isPhotoErrorModalVisible, setIsPhotoErrorModalVisible] = useState<
    boolean
  >(false);

  const handleUploadPicture = (file: File) => {
    if (file) {
      form.setFieldsValue({
        photoFile: file,
      });
      const format = file.type.split("/")[1];
      if (format === "jpg" || format === "jpeg" || format === "png") {
        const objectUrl = URL.createObjectURL(file);
        form.setFieldsValue({
          photo: objectUrl,
        });
      } else {
        setIsPhotoErrorModalVisible(true);
      }
    }
    validateForm();
  };

  return (
    <>
      <Form.Item
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.photo !== currentValues.photo
        }
      >
        {({ getFieldValue }) => {
          const photoURL = getFieldValue("photo");
          return (
            <img
              className={styles.image}
              src={photoURL || defaultImage}
              alt="preview"
            />
          );
        }}
      </Form.Item>

      <Form.Item name="photo">
        <FileUploaderWanda
          className={styles.uploadPhotoBtn}
          clickHandler={handleUploadPicture}
          filter=".png,.jpg,.jpeg"
          disabled={false}
        >
          Select Photo
        </FileUploaderWanda>
      </Form.Item>

      <PhotoUploadErrorModal
        visible={isPhotoErrorModalVisible}
        setVisibility={setIsPhotoErrorModalVisible}
      />
    </>
  );
}

export default ProfilePhoto;
